import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  to?: string;
  target?: string;
  download?: boolean;
  rel?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiLink',
  props: {
    to: { default: '' },
    target: { default: '_self' },
    download: { type: Boolean, default: false },
    rel: { default: '' }
  },
  setup(__props: any) {

const props = __props as { to: string, target: string, download: boolean, rel: string };



const isEmptyToProp = computed(() => [undefined, null, ''].includes(props.to));
const isExternalLink = computed(() => {
  if (!isEmptyToProp.value)
    return props.to?.startsWith('https://') || props.to?.startsWith('http://');
  return false;
});

const path = computed(() => {
  if (!isEmptyToProp.value) {
    if (
      props.to?.endsWith('/') ||
      props.to?.includes('.') ||
      props.to?.includes('#')
    ) {
      return props.to;
    }
    return `${props.to}/`;
  }
  return '#';
});

return { __sfc: true,props, isEmptyToProp, isExternalLink, path }
}

})